import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import store from './redux/store';
import App from './App';
import reportWebVitals from './reportWebVitals';
import moment from 'moment';
import dayjs from 'dayjs';
import 'dayjs/locale/es';

//import './scss/main.sass';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

moment.locale('es');
dayjs.locale('es');

root.render(
  <Provider store={store}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
